"use client";
import * as React from "react";
import styles from "./UseCaseCard.module.css";

function UseCaseCard({
  title,
  description,
  imageSrc,
  video_url,
  imagePosition = "right",
  isFirst = false,
  mode,
}) {
  const cardClass = isFirst
    ? styles.card
    : `${styles.card} ${styles.cardSpacing}`;

  const mediaElement = video_url ? (
    <video 
      src={video_url}
      autoPlay
      loop
      muted
      playsInline
      className={styles.video}
      alt={title}
    />
  ) : (
    <img src={imageSrc} alt={title} className={styles.image} />
  );

  return (
    <article className={cardClass}>
      {imagePosition === "left" && mediaElement}
      <div className={styles.textContent}>
        <h3 className={styles.title}>{title}</h3>
        {mode && <span className={styles.mode}>{mode}</span>}
        <p className={styles.description}>{description}</p>
      </div>
      {imagePosition === "right" && mediaElement}
    </article>
  );
}

export default UseCaseCard;
